module.exports = __webpack_public_path__ + "Flag-724.66c398565653a30e8959168f38478921.svg";